export default "__VITE_ASSET__9BC9j_1M__"